import { render, staticRenderFns } from "./AdminTransactionHistory.vue?vue&type=template&id=4e83b340&scoped=true"
import script from "./AdminTransactionHistory.vue?vue&type=script&lang=js"
export * from "./AdminTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83b340",
  null
  
)

export default component.exports